import React, { Component } from 'react';

class PlayButton extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    onPlayClicked(e) {
        e.target.parentNode.blur();
        e.target.blur();
        e.currentTarget.blur();
        this.props.play();
        this.setState(this.state);
    }

    render() {
        let style = {
        };
        if (this.props.color) {
            style.backgroundColor = this.props.color;
        }
        return (
            <div
              style={style}
              onClick={(e) => this.onPlayClicked(e)}
              className="playpause playpause-user">
                <input
                  checked={!this.props.isPlaying}
                  type="checkbox" value={!this.props.isPlaying}
                  id={"playpause"}
                  name="check">
                </input>
                <label
                  htmlFor={"playpause playpause-user"}
                  tabIndex={1}>
                </label>
              </div>
        );
    }
}


export default PlayButton;
